import React from 'react';
import './Logo.css';

const Logo = ({ className = '' }) => {
  return (
    <div className={`logo-container ${className}`}>
      <div className="logo-emoji">🎓</div>
      
      <div className="logo-text">
        <div className="logo-title">Ezhuthaani</div>
        <div className="logo-subtitle">Education for All</div>
      </div>
    </div>
  );
};

export default Logo;